import { useState, useEffect, useCallback } from "react"
import { Link } from "react-router-dom"
import { colorCode, consoleLog, safetyPercentage } from "../utilities/helpers"
import { getReports } from "../services/chaperonConnector"
import { SESSIONSTORAGE_REPORTS } from "../const/storage"

export default function ReportCarousel() {
    const [reports, setReports] = useState([])

    const maxText = 400

    const loadReports = useCallback(async () => {
        let reports = JSON.parse(sessionStorage.getItem(SESSIONSTORAGE_REPORTS))
        if (reports?.length > 0) {
            // TODO: Set a timeout to refresh the reports data every REPORTS_REFRESH milliseconds
            consoleLog("Loaded reports from session storage.", reports)
        } else {
            reports = await getReports()

            sessionStorage.setItem(
                SESSIONSTORAGE_REPORTS,
                JSON.stringify(reports)
            )
        }

        const filteredReports = reports.filter(
            (report) => report.image !== null
        )

        setReports(filteredReports)
    }, [])

    useEffect(() => {
        loadReports()
    }, [loadReports])

    return (
        <div
            id="carouselCaptions"
            className="carousel slide"
            data-bs-ride="carousel"
        >
            <div className="carousel-indicators">
                {reports.map((_, index) => (
                    <button
                        key={index}
                        type="button"
                        data-bs-target="#carouselCaptions"
                        data-bs-slide-to={index}
                        className={index === 0 ? "active" : ""}
                        aria-current={index === 0 ? "true" : "false"}
                        aria-label={`Slide ${index + 1}`}
                    ></button>
                ))}
            </div>
            <div className="carousel-inner">
                {reports.map((report, index) => (
                    <div
                        key={index}
                        className={`carousel-item ${
                            index === 0 ? "active" : ""
                        }`}
                    >
                        <img
                            src={report?.image}
                            className="d-block w-100 flex-fill rounded-4"
                            style={{ height: "400px" }}
                            alt="..."
                        />
                        <div
                            className="carousel-caption d-none d-md-block fs-6"
                            style={{
                                backgroundColor: "black",
                                opacity: "0.7",
                                borderRadius: "5px",
                            }}
                        >
                            <h5>{report?.title}</h5>
                            <span
                                className={`btn text-start p-1 text-dark bg-${colorCode(
                                    safetyPercentage(report?.overall_safety)
                                )}`}
                            >
                                <strong>{report?.name}</strong>
                            </span>

                            <p className="text-start p-2">
                                <Link
                                    className="App-link"
                                    aria-current="page"
                                    to={`/analysis/${report?.entity_id}`}
                                >
                                    <span className="card-text text-start pt-3">
                                        {report?.review?.length > maxText
                                            ? `${report?.review.substring(
                                                  0,
                                                  maxText
                                              )}...`
                                            : report?.review}
                                    </span>
                                </Link>
                            </p>
                        </div>
                    </div>
                ))}
            </div>
            <button
                className="carousel-control-prev"
                type="button"
                data-bs-target="#carouselCaptions"
                data-bs-slide="prev"
            >
                <span
                    className="carousel-control-prev-icon"
                    aria-hidden="true"
                ></span>
                <span className="visually-hidden">Previous</span>
            </button>
            <button
                className="carousel-control-next"
                type="button"
                data-bs-target="#carouselCaptions"
                data-bs-slide="next"
            >
                <span
                    className="carousel-control-next-icon"
                    aria-hidden="true"
                ></span>
                <span className="visually-hidden">Next</span>
            </button>
        </div>
    )
}
